import type { AccordionItem } from '@kkf/design'

const BODY =
  'Aonsectetur adipiscing elit Aenean scelerisque augue vitae consequat Juisque eget congue velit in cursus leo sodales the turpis euismod quis sapien euismod quis sapien the. E-learning is suitable for students, professionals, and anyone interested.'

/**
 * Shared by the FAQ and Services pages — both show the same three accordion items,
 * so the content lives here once.
 */
export const VOLUNTEER_FAQS: AccordionItem[] = [
  { title: 'Recognition and Fulfillment', body: <p>{BODY}</p> },
  { title: 'Why Join Us as a Volunteer?', body: <p>{BODY}</p> },
  { title: 'Be Part of a Community', body: <p>{BODY}</p> },
]
